var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import get from 'lodash.get';
import React, { Fragment, useContext } from 'react';
import FlightNostoCategory from '../nosto/FlightNostoCategory';
import ChannelContext from '../ChannelContext';
const mockCategory = {
    name: '',
    url: '',
    products: { result: [], totalResults: 0, filters: [] }
};
function getCategory(result) {
    const routeObject = get(result, 'data.route.object');
    const dataCategory = get(result, 'data.category');
    return {
        category: routeObject || dataCategory || mockCategory,
        cacheHit: !!(routeObject || dataCategory)
    };
}
const CategoryRoute = (props) => {
    const { component: CategoryPage } = props, rest = __rest(props, ["component"]);
    const { category, cacheHit } = getCategory(props.result);
    const { selectedChannel } = useContext(ChannelContext);
    return (React.createElement(Fragment, null,
        React.createElement(CategoryPage, Object.assign({}, rest, { category: category, cacheHit: cacheHit })),
        get(selectedChannel, 'settings.nostoAccountId') && (React.createElement(FlightNostoCategory, { category: category, route: get(props.result, 'data.route') }))));
};
export default CategoryRoute;
//# sourceMappingURL=CategoryRoute.js.map